import React, { useEffect, useMemo, useState } from "react";
import {
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Icon,
  Drawer,
  useMediaQuery,
  Divider,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useInstance } from "easy-redux-http-call";
import { AI_getUserData } from "APIs/user";
import menuItem from "menu-items";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Logo } from "assets/iihmain.svg";
import EventNoteIcon from '@mui/icons-material/EventNote';
import ContentPasteGoOutlinedIcon from "@mui/icons-material/ContentPasteGoOutlined";
import { AI_getEmployee } from "APIs/employee";
// import { useInstance } from "easy-redux-http-call";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import EventIcon from '@mui/icons-material/Event';
import ApprovalIcon from '@mui/icons-material/Approval';
import BalanceIcon from '@mui/icons-material/Balance';
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import Snackbar from "@mui/material/Snackbar";
import Alert from '@mui/material/Alert';
import moment from "../../../../node_modules/moment/moment";

const MaxDrawerWidth = 250;
const MinDrawerWidth = 60;

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: ({ open }) => (open ? MaxDrawerWidth : MinDrawerWidth),
    transition: "all .5s ease-in-out",
  },
  drawerPaper: {
    width: ({ open }) => (open ? MaxDrawerWidth : MinDrawerWidth),
    transition: "all .5s ease-in-out",
    overflow: "hidden",
  },
  drawerMainContainer: {
    background: theme.palette.common.white,
    height: "100vh",
  },
  drawerList: {
    marginTop: 60,
  },
  drawerListText: {
    "&>span": {
      whiteSpace: "nowrap",
    },
  },
  drawerIcon: {
    "&.MuiListItemIcon-root": {
      minWidth: "43px",
    },
  },
  hrmsLogo: {
    marginTop: "5px",
    marginLeft: "7px",
    cursor: "pointer",
  },
  navBarDesign: {
    height: "calc(100vh - 72px)",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
}));

function MainDrawer(props) {
  const { open, handleMouseLeave, handleDrawerToggle } = props;

  const classes = useStyles({ open });

  const [menuItems, setMenuItems] = useState([]);
  const userData = useInstance(AI_getUserData);
  const [activeMenuItem, setActiveMenuItem] = useState("dashboard");
  const location = useLocation();

  const navigate = useNavigate();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("warning");

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };
  useEffect(() => {
    if (userData?.data?.user) {

      var newMenuItem = [];
      var settings = { ...menuItem.items[1].children[7] };
      newMenuItem.push(menuItem.items[0].children[0]);
      menuItem.items.map((menu) => {
        if (menu.type !== "admin" && userData.data.user[menu.type]) {
          menu.children.map((menuData) => {
            newMenuItem.push(menuData);
          });
          if (!userData.data.user.in_probation) {
            newMenuItem.push({
              id: "leave",
              title: "Leave",
              type: "item",
              url: "/leave",
              icon: ContentPasteGoOutlinedIcon,
              children: [
                {
                  id: "applyleave",
                  title: "Apply",
                  url: "/leave",
                  icon: ApprovalIcon,
                },
                {
                  id: "balanceleave",
                  title: "Balance",
                  url: "/balanceleave",
                  icon: BalanceIcon,
                },
              ],
            });
          }
          // if(userData.data.user.is_access_to_settings){
          //     leave.children = leave
          // }
          // if user has access to settings tab show them
          if (userData.data.user.is_access_to_settings) {
            settings.children = settings?.children?.filter(
              (child) => child.id !== "holidays"
            );
            newMenuItem.push(settings);
          }
          // if user has access to leave Request details tab show them
          if (userData.data.user.is_access_to_leaveDetails) {
            newMenuItem.push({
              id: "leave_request_details",
              title: "Leave Request Details",
              url: "/leave-request-details",
              icon: CalendarMonthIcon,
            });
            newMenuItem.push({
              id: "leave_calendar",
              title: "Leave Calendar",
              url: "/leave-calendar",
              icon: EventNoteIcon,
            });
          } else if (userData.data.user.is_access_to_leaveCalendar) {
            newMenuItem.push({
              id: "leave_calendar",
              title: "Leave Calendar",
              url: "/leave-calendar",
              icon: EventNoteIcon,
            });
          }
          if(userData.data.user.employee?.notice_period_start_date){
            newMenuItem.push({
              id: "notice",
              title: "Notice Period Handover",
              type: "item",
              url: "/notice-period-handover",
              icon: EventNoteIcon,
            });
          }
          const secondLastIndex = newMenuItem.length - 2;
          newMenuItem.splice(secondLastIndex, 0, newMenuItem.pop());
        } else if (menu.type === "admin") {
          if(userData.data.user?.is_admin === true){
            newMenuItem.push({
              id: "notice",
              title: "Admin Handover Dashboard",
              type: "item",
              url: "/admin_handover_dashboard",
              icon: EventNoteIcon,
            });
          }
          // who has access for is_access_to_incident = true will be shown Incident Module in sidebar !
          if (userData?.data?.user?.is_admin === true || userData?.data?.user?.is_access_to_incident === true) {
                newMenuItem.push({
                  id: "incident",
                  title: "Incident",
                  url: "/get-all-incident",
                  icon: EventIcon,
                });
          }
          menu.children.map((menuData) => {
            let itemToPush = menuData;
            if (menuData.id === "setting" && (userData?.data?.user?.is_admin === true || userData?.data?.user?.role_name === "HR Manager" || userData?.data?.user?.role_name === "admin")) {
              itemToPush = {
                ...menuData,
                children: [
                  ...(menuData.children || []),
                  { id: "live_attendance", title: "Live Attendance", url: "/live-attendance", icon: PeopleAltOutlinedIcon },
                  { id: "punch_analysis", title: "Punch Analysis", url: "/punch-analysis", icon: AccessTimeIcon },
                  { id: "missed_punch_history", title: "Missed Punch Alerts", url: "/missed-punch-history", icon: AccessTimeIcon },
                ],
              };
            }
            if (userData.data.user[itemToPush.type]) {
              newMenuItem.push(itemToPush);
            } else {
              let temp = userData.data.user;
              if (
                temp.is_access_to_dashboard === true &&
                temp.is_access_to_department === true &&
                temp.is_access_to_employee === true &&
                temp.is_access_to_project === true &&
                temp.is_access_to_roles === true &&
                temp.is_access_to_settings === true && // dont delete this comment
                temp.only_employee_view === false
              ) {
                newMenuItem.push(itemToPush);
              }
            }
          });
        }
      });
      setMenuItems(newMenuItem);
    }
  }, [userData]);

  useEffect(() => {
    const storedMenuItemId = localStorage.getItem("activeMenuItem");
    if (storedMenuItemId) {
      setActiveMenuItem(storedMenuItemId);
    }
  }, [localStorage.getItem("activeMenuItem")]);

  useEffect(() => {
    const currentMenuItem = menuItems.find(
      (item) => item.url === location.pathname
    );

    if (currentMenuItem) {
      setActiveMenuItem(currentMenuItem.id);
    }
  }, [location.pathname, menuItems]);
  const handleMenuItemClick = (menu) => {
    if(menu?.id === "notice" && userData?.data?.user?.employee?.notice_period_start_date){
      // console.log(menu)  
      setActiveMenuItem(menu.id)
    }
    const projectId = localStorage.getItem('projectId');
    if (menu.id === 'pms') {
      if (projectId === "object") {
        // navigate('/projects')
        setSnackbarMessage("Please select a project First !");
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
      } else if (projectId) {
        navigate(`projects/${projectId}/detail`);
      } else if (projectId === null) {
        // navigate('/projects')
        setSnackbarMessage("Please select a project first !");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      } else {
        navigate('/projects')
      }
      setActiveMenuItem(menu.id);
    } else {
      navigate(menu.url);
      setActiveMenuItem(menu.id);
    }
    localStorage.setItem("activeMenuItem", menu.id);
  };
  const matchesXs = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const [time, setTime] = useState(0);
  const status = localStorage.getItem('status');

  useEffect(() => {
    let timer;

    const currentWorkingTime = localStorage.getItem("stopwatch-time");
    const curr_task_id = localStorage.getItem("currentTaskId");

    if (curr_task_id === 'null') {
      setTime(0);
      localStorage.removeItem("stopwatch-time");
      return;
    }
    if (curr_task_id === null) {
      setTime(0);
      localStorage.removeItem("stopwatch-time");
      return;
    }

    if (currentWorkingTime) {
      localStorage.setItem("status", true);

      const storedTime = currentWorkingTime.split(" ")[1];
      const [storedHours, storedMinutes, storedSeconds] = storedTime
        .split(":")
        .map(Number);
      const totalTimeInSeconds =
        storedHours * 3600 + storedMinutes * 60 + storedSeconds;

      setTime(totalTimeInSeconds);
    }

    // ✅ CLEAR OLD INTERVAL
    clearInterval(timer);

    // ✅ START TIMER
    timer = setInterval(() => {
      setTime((prevTime) => {
        const updatedTime = prevTime + 1;
        const hours = Math.floor(updatedTime / 3600)
          .toString()
          .padStart(2, "0");
        const minutes = Math.floor((updatedTime % 3600) / 60)
          .toString()
          .padStart(2, "0");
        const seconds = (updatedTime % 60).toString().padStart(2, "0");
        const formattedDate = moment().format("YYYY-MM-DD");
        const newTime = `${formattedDate} ${hours}:${minutes}:${seconds}`;

        localStorage.setItem("stopwatch-time", newTime);
        return updatedTime;
      });
    }, 1000);

    // ✅ HANDLE LOCAL STORAGE EVENT
    const handleStorageUpdate = (event) => {
      if (event.detail.key === "stopwatch-time") {
        // console.log("Storage Updated:", event.detail.newValue);

        if (!event.detail.newValue || event.detail.newValue.includes("00:00:00")) {
          setTime(0);
          return;
        }

        const storedTime = event.detail.newValue?.split(" ")[1];
        const [hours, minutes, seconds] = storedTime?.split(":").map(Number);
        const totalSeconds = hours * 3600 + minutes * 60 + seconds;
        setTime(totalSeconds);
      }
    };

    window.addEventListener("localStorageUpdated", handleStorageUpdate);

    // ✅ CLEANUP
    return () => {
      clearInterval(timer);
      window.removeEventListener("localStorageUpdated", handleStorageUpdate);
    };
  }, []);

  
  return (
    <div>
      {userData?.data?.user ? (
        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
          open={open}
        >
          <div
            className={classes.drawerMainContainer}
            onMouseLeave={!matchesXs ? handleMouseLeave : () => { }}
            onMouseEnter={!matchesXs ? handleDrawerToggle : () => { }}
          >
            <Logo onClick={() => navigate("/")} className={classes.hrmsLogo} />
            <List className={classes.navBarDesign} component="nav">
              <React.Fragment>
                {menuItems.map((menu) => (
                  <>
                    <ListItemButton
                      onClick={() => handleMenuItemClick(menu)}
                      key={menu.id}
                      selected={
                        menu.id === activeMenuItem ||
                        (!open &&
                          menu?.children
                            ?.map((a) => a.id)
                            .includes(activeMenuItem))
                      }
                    >
                      <ListItemIcon className={classes.drawerIcon}>
                        <Icon
                          style={{
                            color:
                              menu.id === activeMenuItem ||
                                (!open &&
                                  menu?.children
                                    ?.map((a) => a.id)
                                    .includes(activeMenuItem))
                                ? "#d46b08"
                                : "#000",
                            fill:
                              menu.id === activeMenuItem ||
                                (!open &&
                                  menu?.children
                                    ?.map((a) => a.id)
                                    .includes(activeMenuItem))
                                ? "#d46b08"
                                : "#000",
                          }}
                          component={
                            menu.icon.type ? menu.icon.type : menu.icon
                          }
                        />
                      </ListItemIcon>
                      <ListItemText className={classes.drawerListText}>
                        {menu.title}
                      </ListItemText>
                    </ListItemButton>
                    {menu?.children?.length > 0 && open && (
                      <List component="div" disablePadding>
                        {menu.children.map((menu) => (
                          <>
                            <ListItemButton
                              onClick={() => handleMenuItemClick(menu)}
                              key={menu.id}
                              selected={menu.id === activeMenuItem}
                              sx={{ pl: 4 }}
                            >
                              <ListItemIcon className={classes.drawerIcon}>
                                <Icon
                                  style={{
                                    color:
                                      menu.id === activeMenuItem
                                        ? "#d46b08"
                                        : "#000",
                                    fill:
                                      menu.id === activeMenuItem
                                        ? "#d46b08"
                                        : "#000",
                                  }}
                                  component={
                                    menu.icon.type ? menu.icon.type : menu.icon
                                  }
                                />
                              </ListItemIcon>
                              <ListItemText className={classes.drawerListText}>
                                {menu.title}
                              </ListItemText>
                            </ListItemButton>
                          </>
                        ))}
                      </List>
                    )}
                  </>
                ))}
              </React.Fragment>
            </List>
          </div>
          <>
            <Snackbar
              open={openSnackbar}
              autoHideDuration={4000}
              onClose={handleSnackbarClose}
              anchorOrigin={{ vertical: "top", horizontal: "right" }} // Positioned at bottom-right
            >
              {/* <MuiAlert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage} */}
              {/* </MuiAlert> */}
              <Alert
                onClose={handleSnackbarClose}
                severity="warning"
                sx={{
                  width: "100%",
                  backgroundColor: "#E27534",
                  color: "white",
                }}
                variant="filled"
              >
                {snackbarMessage}
              </Alert>
            </Snackbar>

          </>
        </Drawer>
      ) : null}
    </div>
  );
}

export default MainDrawer;
